import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { getFormStrucComponentTable } from '../../../../../../../utils/formStruc';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const OeffentlichkeitsarbeitAbschlussEmob: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title="Öffentlichkeitsarbeit" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default OeffentlichkeitsarbeitAbschlussEmob;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Abschlussbericht_Elektro_0130326654_ichkeitsarbeit_Publikationen, type: 'componentTable', tableLabel: 'Publikationen' },
				{ ...P.Abschlussbericht_Elektro_0021194846_tsarbeit_Veroeffentlichungen, type: 'componentTable', tableLabel: 'Veröffentlichungen' },
				{ ...P.Abschlussbericht_Elektro_0173321829_entlichkeitsarbeit_Vortraege, type: 'componentTable', tableLabel: 'Vorträge' },
				{ ...P.Abschlussbericht_Elektro_0193377086_eit_Ausstellungen_Auf_Messen, type: 'componentTable', tableLabel: 'Ausstellungen auf Messen' },
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export function getFormStrucOeffentlichkeitsarbeitAbschlussEmob(application: any): FormStrucItem[] {
	const formStrucCT = getFormStrucComponentTable(application, formStruc());
	return concat(formStrucCT);
}
